/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const maxValueInArray = (array, key) => Math.max(...array.map((obj) => obj[key]));
export const isArrayIdIncludes = (array, key) => {
    const includes = array.filter((a) => a.id === key);
    return includes.length > 0;
};
